import { HStack, Box, Text, IconButton, useBreakpointValue, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, VStack, useDisclosure } from "@chakra-ui/react"
import { useEffect, useRef, useContext} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { LanguageContext, LanguageSelector } from "../context/LanguageContext";


const Header = () => {

    const title = "<Henry GC/>"
    const { isOpen, onOpen, onClose } = useDisclosure()
    const { t } = useContext(LanguageContext)
    const headerRef = useRef(null);
    const isMobile = useBreakpointValue({ base: true, md: false })
    
    // Colores fijos del tema oscuro
    const darkTheme = {
        bg: {
            header: "rgba(0, 0, 0, 0.95)"
        },
        color: "#fff",
        borderColor: "#4a5568"
    }

    useEffect(() => { 
        let prevScrollPos = window.scrollY; 
      
        const handleScroll = () => { 
          const currentScrollPos = window.scrollY; 
          const headerElement = headerRef.current; 
          if (!headerElement) { 
            return; 
          } 
          if (prevScrollPos > currentScrollPos) { 
            headerElement.style.transform = "translateY(0)"; 
          } else { 
            headerElement.style.transform = "translateY(-200px)"; 
          } 
          prevScrollPos = currentScrollPos; 
        } 
        window.addEventListener('scroll', handleScroll) 
      
        return () => { 
          window.removeEventListener('scroll', handleScroll) 
        } 
      }, []); 

    const handleClick = (props) => () =>{
        const id = `${props}`
        const element = document.getElementById(id)
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
        onClose(); // Cierra el drawer en móvil después de hacer click
    };

    const NavLink = ({ href, onClick, children }) => (
        <Text
            as="a"
            href={href}
            onClick={onClick}
            fontSize={["1rem", "1.1rem", "1.2rem"]}
            fontWeight="500"
            color={darkTheme.color}
            cursor="pointer"
            padding="0.5rem 1rem"
            borderRadius="0.5rem"
            transition="all 0.3s ease"
            _hover={{
                background: darkTheme.borderColor,
                transform: "translateY(-2px)",
                textDecoration: "none"
            }}
        >
            {children}
        </Text>
    );

    return (
        <>
        <Box
            position="fixed"
            zIndex="1000"
            top={0} 
            left={0} 
            right={0} 
            translateY={0} 
            transitionProperty="transform, background" 
            transitionDuration=".3s" 
            transitionTimingFunction="ease-in-out"
            ref={headerRef} 
            background={darkTheme.bg.header}
            backdropFilter="blur(10px)"
            borderBottom={`1px solid ${darkTheme.borderColor}`}
            padding="1rem 2rem"
        >
            <HStack
                justifyContent="space-between"
                alignItems="center"
                maxWidth="1200px"
                margin="0 auto"
            >
                {/* Logo/Title */}
                <Text
                    as="a"
                    href="#Portafolio" 
                    onClick={handleClick("title")}
                    fontSize={["1.3rem", "1.5rem", "1.8rem"]}
                    fontWeight="700"
                    color={darkTheme.color}
                    cursor="pointer"
                    fontFamily="'Fira Code', monospace"
                    transition="all 0.3s ease"
                    _hover={{
                        color: "#00D9FF",
                        transform: "scale(1.05)",
                        textDecoration: "none"
                    }}
                >
                    {title}
                </Text>

                {/* Desktop Navigation */}
                {!isMobile && (
                    <HStack spacing="1rem" alignItems="center">
                        <NavLink href="#Acerca_de_mi" onClick={handleClick("perfil")}>
                            {t('nav.perfil')}
                        </NavLink>
                        <NavLink href="#Experiencia" onClick={handleClick("experiencia")}>
                            {t('nav.experiencia')}
                        </NavLink>
                        <NavLink href="#Proyectos" onClick={handleClick("proyects")}>
                            {t('nav.proyectos')}
                        </NavLink>
                        <NavLink href="#Educacion" onClick={handleClick("education")}>
                            {t('nav.educacion')}
                        </NavLink>
                        <NavLink href="#Contacto" onClick={handleClick("contact")}>
                            {t('nav.contacto')}
                        </NavLink>
                        <LanguageSelector />
                    </HStack>
                )}

                {/* Mobile Menu Button */}
                {isMobile && (
                    <HStack spacing="1rem" alignItems="center">
                        <LanguageSelector />
                        <IconButton
                            aria-label="Abrir menú"
                            icon={<FontAwesomeIcon icon={faBars} />}
                            onClick={onOpen}
                            variant="ghost"
                            color={darkTheme.color}
                            _hover={{
                                background: darkTheme.borderColor
                            }}
                            size="lg"
                        />
                    </HStack>
                )}
            </HStack>
        </Box>

        {/* Mobile Drawer */}
        <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
            <DrawerOverlay />
            <DrawerContent background={darkTheme.bg.header}>
                <DrawerCloseButton color={darkTheme.color} />
                <DrawerHeader 
                    borderBottomWidth="1px" 
                    borderColor={darkTheme.borderColor}
                    color={darkTheme.color}
                    fontSize="1.3rem"
                    fontWeight="700"
                >
                    {t('nav.inicio')}
                </DrawerHeader>
                <DrawerBody>
                    <VStack spacing="2rem" alignItems="flex-start" paddingTop="2rem">
                        <NavLink href="#Acerca_de_mi" onClick={handleClick("perfil")}>
                            {t('nav.perfil')}
                        </NavLink>
                        <NavLink href="#Experiencia" onClick={handleClick("experiencia")}>
                            {t('nav.experiencia')}
                        </NavLink>
                        <NavLink href="#Proyectos" onClick={handleClick("proyects")}>
                            {t('nav.proyectos')}
                        </NavLink>
                        <NavLink href="#Educacion" onClick={handleClick("education")}>
                            {t('nav.educacion')}
                        </NavLink>
                        <NavLink href="#Contacto" onClick={handleClick("contact")}>
                            {t('nav.contacto')}
                        </NavLink>
                    </VStack>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
        </>
    )
}

export default Header